module.exports = __webpack_public_path__ + "img/nokhbegan.e429e46a.png";